import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Ardd = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState("");
  const [ChoseServ, setChoseServ] = useState("");
  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };

  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Nationalid === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 7);
    formData.append("local_type", 2);
    formData.append("local_category", ChoseServ);
    formData.append("local_details", desc);
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setChoseServ("");
    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات الأراضي</h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServ}
              onChange={(e) => setChoseServ(e.target.value)}
            >
              
              <MenuItem value={34}>طلب استلام قطعة ارض (الأراضي الحديثة -افراد )</MenuItem>
              <MenuItem value={35}>طلب اعادة تحديد الأراضي (الأراضي الحديثة -افراد )</MenuItem>
              <MenuItem value={36}>طلب استخراج عقد نهائي لأرض مسددة القيمةبالكامل (الأراضي الحديثة -افراد )</MenuItem>
              <MenuItem value={37}>طلب ضم قطعة ارض (الأراضي الحديثة -افراد )</MenuItem>
              <MenuItem value={38}>طلب بيان صلاحية الموقع (الأراضي الحديثة -افراد )</MenuItem>

              <MenuItem value={39}>طلب اعادة معاينة باختلاف المساحة (الأراضي القديمة -افراد )</MenuItem>
              <MenuItem value={40}>طلب تخصيص الأرض (الأراضي القديمة -افراد )</MenuItem>
              <MenuItem value={41}>طلب تغير تخصيص باسم الورثة (الأراضي القديمة -افراد )</MenuItem>
              <MenuItem value={42}>طلب بيان مساحي عن قطعة ارض (الأراضي القديمة -افراد )</MenuItem>

              <MenuItem value={43}>طلب تقسيط ثمن ارض (طلبات مالية -افراد )</MenuItem>
              <MenuItem value={44}>طلب مراجعة متأخرات الأقساط على الأرض (طلبات مالية -افراد )</MenuItem>
              <MenuItem value={45}>طلب تقسيط متأخرات عن المديونية (طلبات مالية -افراد )</MenuItem>

              <MenuItem value={46}>طلب تعديل الكيان القانوني (الأسم -شركات )</MenuItem>
              <MenuItem value={47}>طلب تعديل الكيان القانوني (اضافة شريك -شركات )</MenuItem>
              <MenuItem value={48}>طلب تعديل الكيان القانوني (تنازل عن الأرض للشركاء -شركات )</MenuItem>
              <MenuItem value={49}>طلب تعديل الكيان القانوني (تنازل لشركة اخرى -شركات )</MenuItem>
              <MenuItem value={50}>طلب تغير استخدام الأراضي (شركات)</MenuItem>

              <MenuItem value={51}> طلب تقسيط المديونية لأراضي الأستثمار (طلبات مالية - شركات )</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeNational}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>

        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div>
        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Ardd;
